import createIcon from '../../createIcon';

/**
 * @component @name SwipeLeftAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuMSAxM0MxMS41NiAxNS4yOCAxMy41OCAxNyAxNiAxN0MxOC43NiAxNyAyMSAxNC43NiAyMSAxMkMyMSA5LjI0IDE4Ljc2IDcgMTYgN0MxMy41OCA3IDExLjU2IDguNzIgMTEuMSAxMUg2LjgzTDguNDIgOS40MUw3IDhMMyAxMkw3IDE2TDguNDEgMTQuNTlMNi44MyAxM0gxMS4xWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeLeftAlt = createIcon('SwipeLeftAlt', [
  [
    'path',
    {
      d: 'M11.1 13C11.56 15.28 13.58 17 16 17C18.76 17 21 14.76 21 12C21 9.24 18.76 7 16 7C13.58 7 11.56 8.72 11.1 11H6.83L8.42 9.41L7 8L3 12L7 16L8.41 14.59L6.83 13H11.1Z',
      key: 'h0h8uk',
    },
  ],
]);

export default SwipeLeftAlt;
